import {ModalConstants} from "../constants/modal.constants";

const initialState  = {
    modalType: null,
    modalProps: {
        open: false
    }
};

export function modalReducer(state = initialState, action)  {
    switch (action.type) {
        case ModalConstants.SHOW_MODAL:
            return {
                modalProps: action.modalProps,
                modalType: action.modalType,
                type: action.type
            };
        case ModalConstants.HIDE_MODAL:
            return initialState;
        default:
            return state;
    }
}
